<template>
  <div>
    <div class="flex-layout section-header m-t-20">
      <div class="f-s-1_2">
        <i class="el-icon-setting"></i>
        我的班级
      </div>
      <div class="flex-layout">
        <el-checkbox-group v-if="hasMultiGroupType" v-model="form.groupType" class="m-r-20">
          <el-checkbox :label="EGroupType.administrative">{{groupTypeMap[EGroupType.administrative]}}</el-checkbox>
          <el-checkbox :label="EGroupType.teaching">{{groupTypeMap[EGroupType.teaching]}}</el-checkbox>
        </el-checkbox-group>
        <router-link to="/group/apply" class="m-h-10">
          <el-button type="primary">关联班级</el-button>
        </router-link>
        <el-button type="success" @click="exportWord()" :disabled="loading">导出名单</el-button>
        <el-button @click="$router.back()">返回</el-button>
      </div>
    </div>
    <router-link v-for="group in pagedGroups" :key="group.uid"
                 :to="{path: '/group/detail', query: {uid: group.uid}}"
                 class="item flex-layout">
      <div>
        <div class="title">{{group.name}}</div>
        <div class="info">
          {{group.grade}}级，
          {{stageMap[group.level].name}}，
          {{groupTypeMap[group.group_type]}}，
          {{group.total}}人
        </div>
      </div>
      <div class="flex-layout">
        <template v-if="group.total > group.bind_total && showParentWechat">
          <div class="m-r-10">
            本班有
            <span class="text-red">{{group.total - group.bind_total}}</span>
            位学生家长未绑定账号，无法收到考试或作业通知
          </div>
          <el-popover v-model="group.qrcodeVisible"
                      placement="bottom" width="280" trigger="click">
            <el-button slot="reference" type="primary" @click.native.stop.prevent>
              邀请绑定
            </el-button>
            <div class="text-center" v-if="group.qrcodeVisible">
              <div class="m-b-10">
                请老师使用微信“扫一扫”下方二维码，按提示转发到所任教的班级家长群
              </div>
              <img :src="getQrcode(group)" :alt="getQrcodeUrl(group)">
            </div>
          </el-popover>
        </template>
        <i class="el-icon-arrow-right m-l-20"></i>
      </div>
    </router-link>
    <div class="text-center m-v-20" v-show="filteredGroups.length > pageSize">
      <el-pagination
        layout="prev, pager, next"
        :current-page.sync="page"
        :page-size="pageSize"
        :total="filteredGroups.length"/>
    </div>
  </div>
</template>
<script>
import _keyBy from 'lodash/keyBy'
import qs from 'qs'

import {
  downloadAllGroupStudentsWord,
  EGroupType,
  getGroupList,
  getGroupName,
  getSchoolOtherConfig,
  Stages,
  teacherHost
} from './api'
import { getQrcode } from '../../scripts/utils'

export default {
  data () {
    return {
      loading: false,
      ready: false,
      /**
       * @type {Group[]}
       */
      groups: [],
      stageMap: _keyBy(Stages, s => s.key),
      groupTypeMap: {
        [EGroupType.administrative]: '行政班',
        [EGroupType.teaching]: '教学班',
      },
      showParentWechat: true,
      form: {
        groupType: [],
      },
      EGroupType,
      page: 1,
      pageSize: 10,
    }
  },
  computed: {
    hasMultiGroupType () {
      const groupTypeSet = new Set()
      for (const group of this.groups) {
        groupTypeSet.add(group.group_type)
        if (groupTypeSet.size > 1) return true
      }
      return false
    },
    filteredGroups () {
      const { form } = this
      if (!form.groupType.length || form.groupType.length === 2) return this.groups
      return this.groups.filter(g => form.groupType.includes(g.group_type))
    },
    pagedGroups () {
      const { page, pageSize } = this
      return this.filteredGroups.slice((page - 1) * pageSize, page * pageSize)
    },
  },
  mounted () {
    this.init()
  },
  methods: {
    async init () {
      this.$guard()(async () => {
        const [groups, school] = await Promise.all([
          getGroupList(),
          getSchoolOtherConfig({ school_uid: this.$user.school_uid }),
        ])
        groups.forEach(g => {
          g.qrcodeVisible = false
        })
        this.groups = groups
        this.showParentWechat = !school.config.disable_parent_wechat
        this.ready = true
      })
    },
    /**
     * 获取班级邀请码地址
     * @param group {Group}
     */
    getQrcodeUrl (group) {
      const query = {
        type: 'group',
        uid: group.uid,
        title: getGroupName(group.name),
      }
      return `${location.protocol}//${teacherHost}/mobile/#/parent/group/share?${qs.stringify(query)}`
    },
    getQrcode (group) {
      const url = this.getQrcodeUrl(group)
      return getQrcode({ text: url, size: 160 })
    },
    exportWord () {
      this.$guard()(async () => {
        return downloadAllGroupStudentsWord(this.groups)
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.section-header {
  background-color: #f7f7f7;
  padding: 3px 10px;
  border: 1px solid #eee;
  border-bottom: none;
}

.item {
  padding: 10px 25px;
  background: #fff;
  border: 1px solid #eee;
  margin-bottom: 5px;
  color: #9a9da1;
  text-decoration: none;

  &:hover {
    background-color: #f5faff;
    border-color: #eef3f8;
    color: #9a9da1;
  }

  .title {
    color: #666;
    font-weight: 700;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin: 10px 0;
  }

  .info {
    color: #aaa;
  }
}
</style>
